<template>
  <b-tabs
    v-if="ocorrencia"
    pills
    class="w-100"
  >
    <b-tab
      title="Sobre"
      active
    >
      <b-card
        :title="ocorrencia.titulo"
        :sub-title="new Date(ocorrencia.dataHora) | formatDatetime"
      >
        <b-card-text>
          <p><b>Relator: </b> {{ ocorrencia.relator.nome }}</p>
          <b-alert
            variant="primary"
            show
          >
            {{ ocorrencia.observacoes }}
          </b-alert>
          <p v-html="ocorrencia.descricao" />
        </b-card-text>
      </b-card>
    </b-tab>
    <b-tab title="Imagem">
      <b-img-lazy
        v-if="ocorrencia.foto"
        fluid-grow
        :src="ocorrencia.foto"
      />
    </b-tab>
    <b-tab title="Comentários">
      <comentarios-ocorrencia :ocorrencia="ocorrencia" />
    </b-tab>
  </b-tabs>
</template>

<script>
import { BAlert, BImgLazy } from 'bootstrap-vue'
import ImagemAPI from '@/api/imagem'
import ComentariosOcorrencia from './ComentariosOcorrencia.vue'

export default {
  components: {
    ComentariosOcorrencia,
    BAlert,
    BImgLazy,
  },
  data() {
    return {
      ocorrencia: null,
    }
  },
  created() {
    this.$store.dispatch('livroOcorrencia/clearEventos')
    this.fetchOcorrencia()
  },
  methods: {
    fetchOcorrencia() {
      this.ocorrencia = this.$store.getters['livroOcorrencia/getOcorrencia'](
        Number(this.$route.params.id),
      )
      if (this.ocorrencia) {
        this.fetchImage()
      } else {
        this.$store
          .dispatch('livroOcorrencia/fetchOneOcorrencia', {
            id: this.$route.params.id,
          })
          .then(res => {
            this.ocorrencia = res.data
            this.fetchImage()
          })
      }
    },
    fetchImage() {
      if (this.ocorrencia.idFoto) {
        const self = this
        ImagemAPI.obter(this.ocorrencia.idFoto).then(foto => {
          self.ocorrencia.foto = `data:image/jpeg;base64,${foto.data}`
        })
      }
    },
  },
}
</script>
